import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';

/**
 * The `HeaderPrimary` component displays primary header controls. On the
 * default skin, these are shown just to the right of the forum title.
 */
export default class HeaderMarquee extends Component {

  oninit(vnode) {
    super.oninit(vnode);
    this.curItem = 0;
    this.slideWidth = 0;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    this.setCurrentWidth();
    window.addEventListener('resize', this.getCurrentWidth.bind(this));
    this.setAuto();
  }
  view() {
    return <div class='marquee web'>{this.getMarqueeTextData()}</div>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();

    return items;
  }

  getMarqueeTextData() {
    let data = app.adsbannerData;
    if (data) {
      let list = [];
      list = data.list.marquee;

      if (list) {
        let text = list.map((value) => {
          return (<div class='marquee-item'>{value.text}</div>);
        });
        return text;
      }
    }
    return null;
  }

  setNextPosition() {
    let slides = document.getElementsByClassName('marquee-item');

    document.querySelectorAll('.marquee-item').forEach(element => {
      element.classList.remove('transition');
    });
    let cur = this.curItem;
    slides[cur].style.left = this.slideWidth + 'px';
    setTimeout(() => {
      //add transition
      slides[cur].classList.add('transition');

      //set final transition
      let blockWidth = slides[cur].offsetWidth + 30;
      slides[cur].style.left = "-" + blockWidth + 'px';
      this.curItem++;
      if (this.curItem >= slides.length) this.curItem = 0;

    }, 100);
  }

  getCurrentWidth() {

    let slides = document.getElementsByClassName('marquee-item');
    document.querySelectorAll('.marquee-item').forEach(element => {
      element.classList.remove('transition');
    });
    this.slideWidth = window.innerWidth;
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.left = this.slideWidth + "px";
    }

  }

  setCurrentWidth() {
    this.getCurrentWidth();
  }

  setAuto() {
    this.setNextPosition();
    setTimeout(() => {
      this.setAuto();
    }, 10 * 1000);
  }
}
